@file:OptIn(InternalResourceApi::class)

package terasenior.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/terasenior.shared.generated.resources/"

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_619_299_531)
internal val Res.drawable.logo: DrawableResource by lazy {
      DrawableResource("drawable:logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-836_186_933)
internal val Res.drawable.realistic_after_lunch: DrawableResource by lazy {
      DrawableResource("drawable:realistic_after_lunch", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_after_lunch.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_681_514_667)
internal val Res.drawable.realistic_apple: DrawableResource by lazy {
      DrawableResource("drawable:realistic_apple", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_apple.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(879_994_475)
internal val Res.drawable.realistic_appointment_calendar: DrawableResource by lazy {
      DrawableResource("drawable:realistic_appointment_calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_appointment_calendar.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_429_342_578)
internal val Res.drawable.realistic_banana: DrawableResource by lazy {
      DrawableResource("drawable:realistic_banana", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_banana.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_678_291_324)
internal val Res.drawable.realistic_book: DrawableResource by lazy {
      DrawableResource("drawable:realistic_book", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_book.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(332_260_602)
internal val Res.drawable.realistic_bus: DrawableResource by lazy {
      DrawableResource("drawable:realistic_bus", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_bus.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(665_623_485)
internal val Res.drawable.realistic_cat: DrawableResource by lazy {
      DrawableResource("drawable:realistic_cat", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_cat.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(454_667_942)
internal val Res.drawable.realistic_chair: DrawableResource by lazy {
      DrawableResource("drawable:realistic_chair", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_chair.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_911_204_122)
internal val Res.drawable.realistic_clock: DrawableResource by lazy {
      DrawableResource("drawable:realistic_clock", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_clock.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(494_784_491)
internal val Res.drawable.realistic_cup: DrawableResource by lazy {
      DrawableResource("drawable:realistic_cup", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_cup.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-443_449_758)
internal val Res.drawable.realistic_daily_calendar: DrawableResource by lazy {
      DrawableResource("drawable:realistic_daily_calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_daily_calendar.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(476_170_724)
internal val Res.drawable.realistic_dinner_night: DrawableResource by lazy {
      DrawableResource("drawable:realistic_dinner_night", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_dinner_night.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_030_449_360)
internal val Res.drawable.realistic_dog: DrawableResource by lazy {
      DrawableResource("drawable:realistic_dog", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_dog.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-315_172_238)
internal val Res.drawable.realistic_early_morning: DrawableResource by lazy {
      DrawableResource("drawable:realistic_early_morning", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_early_morning.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-345_062_749)
internal val Res.drawable.realistic_emotions: DrawableResource by lazy {
      DrawableResource("drawable:realistic_emotions", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_emotions.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_641_773_321)
internal val Res.drawable.realistic_hand: DrawableResource by lazy {
      DrawableResource("drawable:realistic_hand", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_hand.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_280_659_347)
internal val Res.drawable.realistic_home_community: DrawableResource by lazy {
      DrawableResource("drawable:realistic_home_community", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_home_community.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_866_104_756)
internal val Res.drawable.realistic_phone: DrawableResource by lazy {
      DrawableResource("drawable:realistic_phone", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_phone.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-536_237_515)
internal val Res.drawable.realistic_seasons: DrawableResource by lazy {
      DrawableResource("drawable:realistic_seasons", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_seasons.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_968_307_684)
internal val Res.drawable.realistic_seasons_landscape: DrawableResource by lazy {
      DrawableResource("drawable:realistic_seasons_landscape", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_seasons_landscape.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_783_202_866)
internal val Res.drawable.realistic_sunrise: DrawableResource by lazy {
      DrawableResource("drawable:realistic_sunrise", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_sunrise.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_153_326_868)
internal val Res.drawable.realistic_week_calendar: DrawableResource by lazy {
      DrawableResource("drawable:realistic_week_calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_week_calendar.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_594_505_647)
internal val Res.drawable.realistic_year_calendar: DrawableResource by lazy {
      DrawableResource("drawable:realistic_year_calendar", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_year_calendar.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_825_034_154)
internal val Res.drawable.realistic_year_months_landscape: DrawableResource by lazy {
      DrawableResource("drawable:realistic_year_months_landscape", setOf(
        ResourceItem(setOf(), "${MD}drawable/realistic_year_months_landscape.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("logo", Res.drawable.logo)
  map.put("realistic_after_lunch", Res.drawable.realistic_after_lunch)
  map.put("realistic_apple", Res.drawable.realistic_apple)
  map.put("realistic_appointment_calendar", Res.drawable.realistic_appointment_calendar)
  map.put("realistic_banana", Res.drawable.realistic_banana)
  map.put("realistic_book", Res.drawable.realistic_book)
  map.put("realistic_bus", Res.drawable.realistic_bus)
  map.put("realistic_cat", Res.drawable.realistic_cat)
  map.put("realistic_chair", Res.drawable.realistic_chair)
  map.put("realistic_clock", Res.drawable.realistic_clock)
  map.put("realistic_cup", Res.drawable.realistic_cup)
  map.put("realistic_daily_calendar", Res.drawable.realistic_daily_calendar)
  map.put("realistic_dinner_night", Res.drawable.realistic_dinner_night)
  map.put("realistic_dog", Res.drawable.realistic_dog)
  map.put("realistic_early_morning", Res.drawable.realistic_early_morning)
  map.put("realistic_emotions", Res.drawable.realistic_emotions)
  map.put("realistic_hand", Res.drawable.realistic_hand)
  map.put("realistic_home_community", Res.drawable.realistic_home_community)
  map.put("realistic_phone", Res.drawable.realistic_phone)
  map.put("realistic_seasons", Res.drawable.realistic_seasons)
  map.put("realistic_seasons_landscape", Res.drawable.realistic_seasons_landscape)
  map.put("realistic_sunrise", Res.drawable.realistic_sunrise)
  map.put("realistic_week_calendar", Res.drawable.realistic_week_calendar)
  map.put("realistic_year_calendar", Res.drawable.realistic_year_calendar)
  map.put("realistic_year_months_landscape", Res.drawable.realistic_year_months_landscape)
}
